import { Department, DepartmentContact } from '@/entities/department';
import { formatPhoneHref } from '@/shared/lib/utils/strings';
import TeamItem from '../TeamItem';
import Typografed from '../Typografed';

export type TeamListProps = {
    departments: Department[];
};

type Props = TeamListProps;

const TeamList = ({ departments }: Props) => {
    const renderContent = (item: DepartmentContact) => {
        switch (item.block) {
            case 'phone':
                return item.link || item.text ? (
                    <div className="team__number text-s">
                        <div className="team__number-title">Общий номер департамента:</div>
                        <a
                            className="team__number-phone"
                            href={item.link || (item.text ? `tel:${formatPhoneHref(item.text)}` : undefined)}
                            target={item.link ? '_blank' : undefined}
                            rel={item.link ? 'noreferrer nofollow' : undefined}
                        >
                            {item.link_text || item.text}
                        </a>
                    </div>
                ) : null;
            case 'email':
                return (
                    <div className="team__number text-s">
                        <div className="team__number-title">Общая электронная почта департамента:</div>
                        <a className="team__number-phone" href={`mailto:${item.text}`}>
                            {item.text}
                        </a>
                    </div>
                );
            case 'link':
                return item.link ? (
                    <div className="team__number text-s">
                        <div className="team__number-title">Общий номер департамента:</div>
                        <a className="team__number-phone" target="_blank" rel="noreferrer noopener" href={item.link}>
                            {item.link_text || item.link}
                        </a>
                    </div>
                ) : null;
            case 'text':
                return <p className="text-s">{item.text}</p>;
        }
    };

    return departments.map(
        (department, i) =>
            department.members.filter((item) => item.name).length > 0 && (
                <div key={i} className="team__wrapper">
                    <div className="team-block__left">
                        {department.name && (
                            <div className="team__descr">
                                <div className="team__descr-inner text-l">
                                    <Typografed>{department.name}</Typografed>
                                </div>
                            </div>
                        )}
                        {department.contacts.map((item, i) => (
                            <div key={i}>{renderContent(item)}</div>
                        ))}
                    </div>

                    <div className="team-block__right">
                        <ul className="team__list list-unstyled">
                            {department.members
                                .filter((item) => item.name)
                                .map((item, i) => (
                                    <TeamItem tag="li" teamPerson={item} key={i} />
                                ))}
                        </ul>
                    </div>
                </div>
            ),
    );
};

export default TeamList;
